import { render } from "./section-images-grid.vue?vue&type=template&id=6064e4b7"
import script from "./section-images-grid.vue?vue&type=script&lang=js"
export * from "./section-images-grid.vue?vue&type=script&lang=js"

import "./section-images-grid.vue?vue&type=style&index=0&id=6064e4b7&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__